export enum CustomTemplateDocumentHeader {
  default = 0,
  // PO
  purchaseOrders = 1,
  // RI
  receivingInventory = 3,
  // QT
  advertisingContract = 5,
  deliveryNote = 7,
  jobOrder = 9,
  priceQuotation = 11,
  quotation = 13,
  salesJobOrder = 15,
  serviceContract = 17,
  summaryTimesheet = 19,
  // BL
  billingNote = 21,
  billingNoteInvoice = 23,
  deliveryBill = 25,
  deliveryNoteInvoice = 27,
  invoice = 29,
  // INV
  deliveryNoteInvoiceTaxInvoice = 31,
  deliveryNoteInvoiceTaxInvoicePlusReceipt = 33,
  deliveryNoteTaxInvoice = 35,
  deliveryNoteTaxInvoicePlusReceipt = 37,
  invoiceTaxInvoice = 39,
  invoiceTaxInvoicePlusReceipt = 41,
  taxInvoice = 43,
  taxInvoicePlusReceipt = 45,
  taxInvoiceReceipt = 47,
  // RE
  receipt = 49,
  // CN
  creditNote = 51,
  creditNoteTaxInvoice = 53,
  // DN
  debitNote = 55,
  debitNoteTaxInvoice = 57,
  // CA
  deliveryNoteTaxInvoiceReceiptCash = 59,
  taxInvoiceReceiptCash = 61,
}
